/**
 * PEER_CONNECTION_ADAPTER_EVENT_TYPE
 * ----------------------------------
 *
 * Adapter-level WebRTC runtime event vocabulary.
 *
 * These are runtime facts observed from the RTCPeerConnection layer.
 * They are not reducer/controller events directly.
 */
export const PEER_CONNECTION_ADAPTER_EVENT_TYPE = {
    CONNECTION_STATE_CHANGED: "CONNECTION_STATE_CHANGED",
    ICE_GATHERING_STATE_CHANGED: "ICE_GATHERING_STATE_CHANGED",
    NEGOTIATION_NEEDED: "NEGOTIATION_NEEDED",
    LOCAL_ICE_CANDIDATE: "LOCAL_ICE_CANDIDATE",
    REMOTE_MEDIA_UPDATED: "REMOTE_MEDIA_UPDATED",
    ERROR: "ERROR",
};
